<template>
    <div class="announcement-details">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.push({ name: 'dashboard' });">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Announcement Details
                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc" @click="$router.push({ name: 'announcementsCreate' })">Create Announcement</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="row">
                <transition name="fade" mode="out-in">
                    <div v-show="toggleFilter" id="side-filter-col" class="col-lg-3">
                        <div class="side-filter">

                            <div class="title">
                                Filter
                            </div>

                            <div class="form-group">
                                <div class="label">Target Users</div>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="tl" type="checkbox" name="target_user" value="TL" class="custom-control-input" v-model="filter.target_user">
                                        <label class="" for="tl">TL</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input id="ba" type="checkbox" name="target_user" value="BA" class="custom-control-input" v-model="filter.target_user">
                                        <label class="" for="ba">BA</label>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-action">
                                <button type="button" class="btn btn-ecdc btn-block" @click="setFilter">Apply</button>
                                <button type="button" class="btn btn-link btn-block text-light" @click="clearFilter">Clear Filter</button>
                            </div>
                        </div>
                    </div>
                </transition>

                <div id="table-content-col" :class="toggleFilter ? 'col-lg-9 filter-expanded' : 'col-lg'">

                    <div class="table-options row justify-content-between align-items-center">
                        <div class="col-sm">
                            <button @click='toggleFilter = !toggleFilter' type="button" class="btn btn-ecdc btn-filter">Filter</button>

                            <!-- <div class="table-search form-inline d-inline-block ml-4">
                                <input type="text" class="form-control" placeholder="Search by keyword">                         <button type="button" class="btn btn-ecdc btn-circle">
                                    <app-icon-search></app-icon-search>
                                </button>       
                            </div> -->
                        </div>
                        <div class="col-sm mt-sm-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateTop"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-striped table-hover result-table">
                            <thead>
                                <tr>
                                    <th>Announcement Time</th>
                                    <th>Title</th>
                                    <th>Preview</th>
                                    <th>Target Users</th>
                                    <th>Created Time</th>
                                    <th>Created by</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="(announcement) in announcementsData" :key="announcement.id">
                                    <td>{{ announcement.to_announce_at }}</td>
                                    <td class="case-ignore">{{ announcement.title }}</td>
                                    <td class="case-ignore">{{ announcement.message }}</td>
                                    <td>{{ announcement.target_user }}</td>
                                    <td>{{ announcement.created_at }}</td>
                                    <td>{{ announcement.created_by }}</td>
                                    <td class="text-center" >
                                        <button class="btn btn-link btn-icon icon-right" @click="view(announcement.id)">
                                            View 
                                            <font-awesome-icon class="icon" :icon="['fas', 'angle-right']" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="row justify-content-between align-items-center table-options">
                        <div class="col-lg col-6">
                            <select class="form-control custom-select" v-model="pageLimit" @change="pagination(1)">
                                <option value="15">15</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            per page
                        </div>
                        <div class="col-lg text-lg-center text-right col-6">
                            {{ showingResults }}
                        </div>
                        <div class="col-lg mt-lg-0 mt-3">
                            <app-paginate
                                :page-count="totalPage"
                                :click-handler="pagination"
                                :prev-text="'&laquo;'"
                                :next-text="'&raquo;'"
                                ref="paginateBottom"
                                :container-class="'pagination justify-content-end'">
                            </app-paginate>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import { getAnnouncements } from '../api'
import Loader from './Loader.vue'
import Paginate from 'vuejs-paginate'
// import IconSearch from '../svg/Search.vue'
import { getProj } from '../helpers/index'

export default {
    components: {
        appLoader: Loader,
        appPaginate: Paginate,
        // appIconSearch: IconSearch,
    },
    data() {
        return {
            filter: {
                target_user: [],
                proj_id: "2"
            },
            regions: [],
            regionOptions: [],
            areas: [],
            areaOptions: [],
            announcementsData: "",
            isLoading: true,
            totalPage: 0,
            pageLimit: 15,
            showingResults: "",
            toggleFilter: true
        }
    },
    async mounted() {
        this.filter.proj_id = getProj().projId;
        await this.getAnnouncements(1);
        this.isLoading = false;
    },
    methods: {
        async getAnnouncements(pageNum) {

            try {

                const result = await getAnnouncements(this.filter, pageNum, this.pageLimit);
                this.announcementsData = result.data.announcements.data;
                this.totalPage = result.data.announcements.total / this.pageLimit;

                if(this.totalPage % 1 !== 0)
                    this.totalPage = parseInt(this.totalPage) + 1;
                else
                    this.totalPage = parseInt(this.totalPage);

                let startPage = 1;

                if(pageNum !== 1)
                    startPage = (this.pageLimit * (pageNum - 1)) + 1;

                let endPage = pageNum * this.pageLimit;

                if(endPage >= result.data.announcements.total)
                    endPage = result.data.announcements.total;

                this.showingResults = "Showing " + startPage + " - " + endPage + " of " + result.data.announcements.total + " results";
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async pagination(pageNum) {

            this.isLoading = true;

            if(pageNum !== 0)
                this.$refs.paginateTop.selected = this.$refs.paginateBottom.selected = pageNum;
            else
                pageNum = this.$refs.paginateBottom.selected;

            await this.getAnnouncements(pageNum);

            this.isLoading = false;
        },
        clearFilter() {

            this.filter.target_user = [];
        },
        async setFilter() {

            this.isLoading = true;
            await this.getAnnouncements(1);
            this.isLoading = false;
        },
        view(id) {
            this.$router.push({ name: "announcementsDetail" , params: { 'id': id }});
        },
    }
}
</script>